import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import '../../styles/CommonStyles.css';

function AboutUsPage() {
  return (
    <div className="page-container">
      <Header />
      
      <div className="page-header">
        <h1>ABOUT BANGALORE VALUERS' ASSOCIATION</h1>
        <p>Uniting Valuers Nationwide for a Unified Cause & Strategic Reforms</p>
      </div>
      
      <section className="content-section">
        <div className="about-section">
          <h2>OUR STORY</h2>
          <p>
            Bangalore Valuers' Association (BVA) was established in 2018 as a non-profit organization 
            dedicated to fostering professional excellence among valuation professionals, particularly 
            in the Securities and Financial Assets (SFA) category. What began as a small group of passionate 
            valuation experts has now grown into a nationwide community of professionals committed to 
            advancing the valuation profession in India.
          </p>
          
          <div className="about-image" style={{ 
            height: '300px', 
            background: 'url(https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderRadius: '8px',
            margin: '2rem 0'
          }}></div>
          
          <h2>OUR MISSION & VISION</h2>
          <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', marginBottom: '2rem' }}>
            <div style={{ 
              flex: 1, 
              minWidth: '300px',
              backgroundColor: 'var(--dark-blue-bg)',
              borderRadius: '8px',
              padding: '2rem',
              color: 'white'
            }}>
              <h3 style={{ marginBottom: '1rem' }}>Our Mission</h3>
              <p>
                To foster professional excellence in the field of valuation through continuous education, 
                knowledge sharing, and networking opportunities. We aim to create a collaborative environment 
                where valuation professionals can grow together, stay updated with industry trends, 
                and contribute to the advancement of valuation practices in India.
              </p>
            </div>
            
            <div style={{ 
              flex: 1, 
              minWidth: '300px',
              backgroundColor: 'var(--dark-blue-bg)',
              borderRadius: '8px',
              padding: '2rem',
              color: 'white'
            }}>
              <h3 style={{ marginBottom: '1rem' }}>Our Vision</h3>
              <p>
                To be the premier association for valuation professionals in India, recognized for our 
                commitment to excellence, integrity, and innovation in the field of valuation. We envision 
                a community of highly skilled and ethical valuers who set the standard for professional 
                practice and contribute to the economic growth and stability of our nation.
              </p>
            </div>
          </div>
          
          <h2>CORE VALUES</h2>
          <div className="values-grid" style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
            gap: '1.5rem',
            marginBottom: '2rem'
          }}>
            <div className="value-card" style={{ 
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '1.5rem',
              boxShadow: 'var(--box-shadow)'
            }}>
              <h3 style={{ color: 'var(--primary-color)', marginBottom: '1rem' }}>Excellence</h3>
              <p>We strive for the highest standards of professional competence and service quality in all our endeavors.</p>
            </div>
            
            <div className="value-card" style={{ 
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '1.5rem',
              boxShadow: 'var(--box-shadow)'
            }}>
              <h3 style={{ color: 'var(--primary-color)', marginBottom: '1rem' }}>Integrity</h3>
              <p>We uphold honesty, transparency, and ethical conduct in all professional dealings and association activities.</p>
            </div>
            
            <div className="value-card" style={{ 
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '1.5rem',
              boxShadow: 'var(--box-shadow)'
            }}>
              <h3 style={{ color: 'var(--primary-color)', marginBottom: '1rem' }}>Collaboration</h3>
              <p>We believe in the power of shared knowledge and fostering professional relationships for collective growth.</p>
            </div>
            
            <div className="value-card" style={{ 
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '1.5rem',
              boxShadow: 'var(--box-shadow)'
            }}>
              <h3 style={{ color: 'var(--primary-color)', marginBottom: '1rem' }}>Innovation</h3>
              <p>We embrace new ideas, methodologies, and technologies to advance the profession of valuation.</p>
            </div>
          </div>
          
          <h2>WHAT WE DO</h2>
          <p>
            At BVA, we provide a platform for valuation professionals to enhance their knowledge, skills, 
            and network through a variety of programs and initiatives:
          </p>
          
          <ul style={{ marginLeft: '2rem', marginBottom: '2rem' }}>
            <li style={{ marginBottom: '1rem' }}>
              <strong>Educational Programs:</strong> We conduct regular workshops, webinars, and seminars on various 
              aspects of valuation, led by industry experts and thought leaders.
            </li>
            <li style={{ marginBottom: '1rem' }}>
              <strong>Networking Opportunities:</strong> Our events bring together professionals from across the country, 
              facilitating valuable connections and knowledge exchange.
            </li>
            <li style={{ marginBottom: '1rem' }}>
              <strong>Resource Sharing:</strong> We provide members with access to valuable resources, including research 
              papers, case studies, and valuation tools.
            </li>
            <li style={{ marginBottom: '1rem' }}>
              <strong>Advocacy:</strong> We represent the interests of valuation professionals before regulatory bodies 
              and work towards the advancement of the profession.
            </li>
          </ul>
          
          <div style={{ 
            backgroundColor: 'var(--dark-blue-bg)',
            color: 'white',
            padding: '2rem',
            borderRadius: '8px',
            textAlign: 'center',
            marginBottom: '2rem'
          }}>
            <h3 style={{ marginBottom: '1rem' }}>Join Our Community</h3>
            <p style={{ marginBottom: '1.5rem' }}>
              Become a part of BVA and connect with a network of valuation professionals dedicated to 
              excellence and continuous learning.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
              <Link to="/register" className="btn btn-primary" style={{textDecoration: 'none'}}>BECOME A MEMBER</Link>
              <Link to="/contact" className="btn btn-light" style={{textDecoration: 'none'}}>CONTACT US</Link>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}

export default AboutUsPage;
